@if (id && isLoaded) {
    <div class="control-screen-system" menuSystem [cerrixTab]="tab">
        <div
            class="control-screens"
            menuItemId="Control execution"
            [attr.name]="'executionOverview.menuControlExecution' | t"
            menuicon="fas fa-shield-alt"
            menusystemsubmenu
        >
            <div
                menuItemId="menuRecentUpcoming"
                [attr.name]="'executionOverview.menuRecentUpcoming' | t"
                menuicon="fas fa-info-circle"
                menusystemitem
            >
                @if (recentUpcomingConfig) {
                    <generic-list-manager [config]="recentUpcomingConfig"></generic-list-manager>
                    <control-detail-overview
                        [ControlGuid]="id"
                        [Label]="'executionOverview.linkedControlLabel' | t"
                        [HideOpenControlButton]="false"
                        [HideControlDetails]="false"
                        [HideDesignScore]="true"
                        [HideEffectivenessScore]="true"
                    ></control-detail-overview>
                }
            </div>
            @if (
                permissions.canCreateTaskseries ||
                permissions.canEditTaskseries ||
                permissions.canDeleteTaskseries
            ) {
                <div
                    menuItemId="menuTaskSeries"
                    [attr.name]="'executionOverview.menuTaskSeries' | t"
                    menuicon="fas fa-info-circle"
                    menusystemitem
                >
                    <generic-list-manager [config]="taskSeriesConfig"></generic-list-manager>
                </div>
            }

            <div
                menuItemId="menuAllControlExecutions"
                [attr.name]="'executionOverview.menuAllControlExecutions' | t"
                menuicon="fas fa-info-circle"
                menusystemitem
            >
                @if (allControlExecutionsConfig) {
                    <generic-list-manager
                        [config]="allControlExecutionsConfig"
                    ></generic-list-manager>

                    <control-detail-overview
                        [ControlGuid]="id"
                        [Label]="'executionOverview.linkedControlLabel' | t"
                        [HideOpenControlButton]="false"
                        [HideControlDetails]="false"
                        [HideDesignScore]="true"
                        [HideEffectivenessScore]="true"
                    ></control-detail-overview>
                }
            </div>
        </div>
    </div>
}
